// src/pages/PlayMaze.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CrazyMaze        from "../game/crazy/CrazyMaze";
import CompletionModal  from "../game/crazy/CompletionModal";
import "./PlayScreen.css";   // <── new
import MysteryBoxModal from "../game/crazy/MysteryBoxModal"; // adjust path as needed
import TouchControls from "../game/crazy/TouchControls"; 



export default function EnhancedPlayMaze() {
 

const navigate = useNavigate();

const isTouchDevice =
  typeof window !== "undefined" &&
  ("ontouchstart" in window || navigator.maxTouchPoints > 0);

const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;





const sceneRef = useRef(null);
      // controls modal visibility

  const [playerName, setPlayerName] = useState("Explorer");
  const [difficulty, setDifficulty] = useState("medium");
  const [playerEmoji, setPlayerEmoji] = useState("🐼");
  const [score, setScore] = useState(0);
  
const goalMessages = {
  "🦄": "Mission for 🦄 is to find the Floating ✨ & Collect All Treasures!",
  "⛵": "Mission for ⛵ is to reach the 🏝️ & Collect All Treasures!",
  "🐬": "Mission for 🐬 is to swim to the 🔶 & Collect All Treasures!",
  "🧑‍🚀": "Mission for 🧑‍🚀 is to reach the 🚀 & Collect All Treasures!",
  "🧜": "Mission for 🧜 is to seek the 🔮 & Collect All Treasures!",
  "🐘": "Mission for 🐘 is to find the 🌳 & Collect All Treasures!"
};

const fallbackMessage = "Reach the Goal & Collect All Treasures!";
const message = goalMessages[playerEmoji] || fallbackMessage;

  const [gameStats, setGameStats] = useState({
    gemsCollected: 0,
    totalGems: 0,
    timeTaken: 0,
    stepsTaken: 0,
     shortestPathLen: 0
  });
  
  // CompletionModal state
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const [finalStats, setFinalStats] = useState(null);

  // Load saved settings
  useEffect(() => {
    const savedName = localStorage.getItem("player-name") || localStorage.getItem("adventure-name") || "Explorer";
    const savedDifficulty = localStorage.getItem("maze-difficulty") || "medium";
    const savedEmoji = localStorage.getItem("player-emoji") || localStorage.getItem("player-avatar") || "🐼";
    
    
    
    setPlayerName(savedName);
    setDifficulty(savedDifficulty);
    setPlayerEmoji(savedEmoji);
  }, []);

  const getGoalProgressPercentage = () => {
  const { stepsTaken, shortestPathLen } = gameStats;
  if (!stepsTaken || !shortestPathLen || stepsTaken <= 0) return 0;
  return Math.min((shortestPathLen / stepsTaken) * 100, 100);
};


  // Maze settings state
  const [showSettings, setShowSettings] = useState(false);
  const [mazeSettings, setMazeSettings] = useState({
    rows: 21,
    columns: 21,
    entries: "top and bottom",
    bias: "none"
  });

  // Load maze settings
  useEffect(() => {
    const savedSettings = JSON.parse(localStorage.getItem("maze-settings") || "{}");
    if (savedSettings.rows || savedSettings.columns) {
      setMazeSettings(prev => ({ ...prev, ...savedSettings }));
    }
  }, []);

  const handleSettingsChange = (key, value) => {
    setMazeSettings(prev => ({ ...prev, [key]: value }));
  };

  const applySettings = () => {
    localStorage.setItem("maze-settings", JSON.stringify(mazeSettings));
    window.location.reload();
  };

  // Timer for game duration
  useEffect(() => {
    const startTime = Date.now();
    const timer = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      setGameStats(prev => ({ ...prev, timeTaken: elapsed }));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleScoreChange = (newScore) => {
    setScore(newScore);
  };

  const handleGameOver = (finalStats) => {
    setGameStats(prev => ({ ...prev, ...finalStats }));
    setFinalStats(finalStats);
    setShowCompletionModal(true);
  };

  // Handle step updates from the maze game
  const handleStepUpdate = (steps) => {
    
    setGameStats(prev => ({ ...prev, stepsTaken: steps }));
  };
  const handlePathLengthUpdate = (length) => {
  setGameStats(prev => ({ ...prev, shortestPathLen: length }));
};


  // Handle gem collection updates
 const handleGemUpdate = (collected, total) => {
  
  setGameStats(prev => ({
    ...prev,
    gemsCollected: collected,
    totalGems: total
  }));
};



  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const getProgressPercentage = () => {
    if (gameStats.totalGems === 0) return 0;
    return (gameStats.gemsCollected / gameStats.totalGems) * 100;
  };

  const createSparkle = () => {
    return (
      <div 
        key={Math.random()} 
        className="sparkle" 
        style={{
          left: Math.random() * 100 + '%',
          top: Math.random() * 100 + '%',
          animationDelay: Math.random() * 3 + 's'
        }}
      />
    );
  };

  return (
    <div className="play-screen-bg">
      {/* Animated Background Elements */}
      <div className="bg-elements">
        <div className="floating-cloud cloud1">☁️</div>
        <div className="floating-cloud cloud2">☁️</div>
        <div className="floating-cloud cloud3">☁️</div>
        
        {/* Generate sparkles */}
        {Array.from({ length: 8 }, (_, i) => createSparkle())}
      </div>

      {/* Enhanced Game Header */}
      <header className="game-header-enhanced fixed top-0 left-0 right-0 z-50 p-4">
        <div className="flex justify-between items-center max-w-7xl mx-auto">
          {/* Game Title with Player Name */}
          <div className="flex items-center gap-3">
            <span className="text-2xl">{playerEmoji}</span>
            <h1 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-pink-500 via-fuchsia-500 to-purple-600 text-transparent bg-clip-text drop-shadow-md">
  Let's Go, {playerName}!
</h1>

          </div>
          
          {/* Game Stats */}
          {/* Game Stats (Themed) */}
<div className="hidden md:flex items-center gap-6 text-md font-semibold tracking-wide text-white drop-shadow-sm">
  <div className="flex items-center gap-1">
    <span className="text-yellow-300">⭐</span>
    <span className="game-title-gradient font-bold">{score}</span>
  </div>
  <div className="flex items-center gap-1">
    <span className="text-blue-300">💎</span>
    <span className="game-title-gradient font-bold">
      {gameStats.gemsCollected}/{gameStats.totalGems}
    </span>
  </div>
  <div className="flex items-center gap-1">
    <span className="text-purple-300">⏱️</span>
    <span className="game-title-gradient font-bold">
      {formatTime(gameStats.timeTaken)}
    </span>
  </div>
  <div className="flex items-center gap-1">
    <span className="text-pink-200">👣</span>
    <span className="game-title-gradient font-bold">{gameStats.stepsTaken}</span>
  </div>
  <div className="flex items-center gap-6">
  {/* 💎 Gem Progress Ring */}
  <div className="flex items-center gap-1">
    <div className="w-6 h-6 relative">
      <svg className="absolute inset-0" viewBox="0 0 60 60">
        <circle
          className="text-gray-300"
          cx="30"
          cy="30"
          r="26"
          fill="none"
          strokeWidth="4"
          stroke="currentColor"
        />
        <circle
          className="text-blue-500 transition-all duration-300"
          cx="30"
          cy="30"
          r="26"
          fill="none"
          strokeWidth="4"
          stroke="currentColor"
          strokeDasharray={`${(gameStats.gemsCollected / gameStats.totalGems)
 * 163 || 0} 163`}
          strokeLinecap="round"
        />
      </svg>
    </div>
    <span className="text-xs text-gray-700">{gameStats.gemsCollected}/{gameStats.totalGems}</span>

  </div>
</div>
  


</div>


          {/* Mobile Stats (simplified) */}
          <div className="flex md:hidden items-center gap-4 text-sm">
            <span className="stat-value font-bold">⭐ {score}</span>
            <span className="stat-value font-bold">💎 {gameStats.gemsCollected}</span>
            <span className="stat-value font-bold">👣 {gameStats.stepsTaken}</span>
          </div>

          {/* Home Button */}
<button
  onClick={() => {
    // 🧹 Clear maze settings when going home
    localStorage.removeItem("maze-settings");
    
    navigate("/home");
  }}
  className="px-4 py-2 rounded-full bg-gradient-to-r from-orange-500 to-red-600 text-white font-semibold shadow-md hover:scale-105 transition-all"


>
  🏠 Home
</button>
        </div>
      </header>
{/* Adventure Header */}
      <div className="adventure-context hidden sm:flex absolute top-[5.75rem] left-[53%] transform -translate-x-1/2 px-5 py-2 rounded-full items-center gap-2 bg-white/80 backdrop-blur-sm shadow text-sm text-gray-800 z-30">
  <span className="text-lg">🗺️</span>
  <span className="font-medium">{message}</span>
</div>




      {/* Main Game Area - Fixed positioning to prevent scroll */}
      <div className="fixed inset-0 flex flex-col items-center justify-center pt-20 pb-8 px-4 z-10">
        {/* Remove the white container - render maze directly */}
        <div className="relative">
          

          {/* Maze Game Component - No container wrapper */}
        <CrazyMaze
  playerEmoji={playerEmoji}
  difficulty={difficulty}
  onScoreChange={handleScoreChange}
  onGameOver={handleGameOver}
  onStepUpdate={handleStepUpdate}
  onGemUpdate={handleGemUpdate}
  onPathLengthUpdate={handlePathLengthUpdate}
  sceneRef={sceneRef}
/>


        </div>

{isTouchDevice && (
  <TouchControls onMove={(dir) => sceneRef.current?.movePlayer?.(dir)} />
)}


       


      </div>

      {/* Enhanced Settings Panel */}
      <div 
        className="fixed right-4 top-1/2 transform -translate-y-1/2 z-40"
        onMouseEnter={() => setShowSettings(true)}
        onMouseLeave={() => setShowSettings(false)}
      >
        <div className="flex flex-col items-end">
          {/* Settings Icon */}
          {!(isTouchDevice && isMobile) && (
  <div className="settings-enhanced w-12 h-12 rounded-full flex items-center justify-center cursor-pointer mb-2">
    <span className="text-xl">⚙️</span>
  </div>
)}


          {/* Expanded Settings Panel */}
          {showSettings && (
            <div className="settings-enhanced rounded-xl p-4 w-64 transform transition-all duration-300 ease-out">
              <h3 className="font-bold text-gray-800 mb-4 text-center">Maze Settings</h3>
              
              <div className="space-y-4">
                {/* Rows */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Rows:</label>
                  <input
                    type="number"
                    min={21}
                    max={60}
                    value={mazeSettings.rows}
                    onChange={(e) => handleSettingsChange('rows', Number(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  />
                </div>

                {/* Columns */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Columns:</label>
                  <input
                    type="number"
                    min={21}
                    max={60}
                    value={mazeSettings.columns}
                    onChange={(e) => handleSettingsChange('columns', Number(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  />
                </div>

                {/* Maze Entries */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Maze Entries:</label>
                  <select
                    value={mazeSettings.entries}
                    onChange={(e) => handleSettingsChange('entries', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  >
                    <option value="top and bottom">Top and Bottom</option>
                    <option value="left and right">Left and Right</option>
                    <option value="diagonal">Diagonal</option>
                  </select>
                </div>

                {/* Bias */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Bias:</label>
                  <select
                    value={mazeSettings.bias}
                    onChange={(e) => handleSettingsChange('bias', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  >
                    <option value="none">None</option>
                    <option value="horizontal">Horizontal</option>
                    <option value="vertical">Vertical</option>
                  </select>
                </div>

                {/* Apply Button */}
                <div className="flex justify-center mt-4">
  <button
    onClick={applySettings}
    className="bg-gradient-to-r from-pink-500 to-purple-500 text-white font-semibold py-2 px-4 rounded-lg shadow-md hover:scale-105 transition-transform duration-300"
  >
    Apply Settings
  </button>
</div>

              </div>
            </div>
          )}
        </div>
      </div>




      {/* Completion Modal */}
      {showCompletionModal && finalStats && (
        <CompletionModal
          show={showCompletionModal}
          onClose={() => setShowCompletionModal(false)}
          stats={finalStats}
          name={playerName}
          difficulty={difficulty}
        />
      )}
   
    </div>
  );
}